<form>
    <div class="modal-header">
        <h5 class="modal-title d-flex align-items-center text-capitalize">
            <i class="bx bx-task me-1 font-20 text-primary"></i> Employee Exam - {{context?.employeeName}}
        </h5>

        <div class="d-flex align-items-center">
            <span class="timer-wrapper d-flex align-items-center me-3"> 
                <i class="bx bx-timer timer-icon"></i> 
                <span class="timer-text ms-1">{{ timer }}</span>
            </span>            
        <button type="button" class="btn-close" aria-label="Close" (click)="confirmCloseModal()"></button>
    </div>
    </div>
    <div class="card shadow-sm p-3 mb-3">
        <div class="card-body">
            <div class="row g-3 mb-2">
                <div class="course-details-container p-4">
                    <div class="row">
                        <div class="col-md-4 mb-3">
                            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                                <div class="d-flex flex-column">
                                    <span class="text-muted mb-2">Course Name</span>
                                    <span class="fw-medium text-capitalize">{{ course.employeeName || 'N/A' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                                <div class="d-flex flex-column">
                                    <span class="text-muted mb-2">Course Code</span>
                                    <span class="fw-medium">{{ course.employeeCode || 'N/A' }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 mb-3">
                            <div class="course-card bg-white p-3 rounded shadow-sm h-100">
                                <div class="d-flex flex-column">
                                    <span class="text-muted mb-2">Duration (In days)</span>
                                    <span class="fw-medium">{{ course.duration || 'N/A' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="question-section mt-4">
                    <div class="question-header mb-4">
                        <span class="question-badge me-3">Question {{ currentIndex + 1 }}</span>
                        <span class="category-badge">{{ flatQuestions[currentIndex]?.category }}</span>
                    </div>
                    <h4 class="question-text mb-4">{{ flatQuestions[currentIndex]?.question }}</h4>
                    <div class="options-container">
                        <div class="option-item mb-3"
                            *ngFor="let choice of flatQuestions[currentIndex]?.questionChoice; let i = index">
                            <label class="option-label" [for]="'option_' + i">
                                <div class="radio-wrapper">
                                    <input type="radio" [id]="'option_' + i" class="form-check-input"
                                        [name]="'question_' + currentIndex" [value]="choice.id"
                                        [(ngModel)]="selectedAnswers[currentIndex]" />
                                </div>
                                <span class="option-text">{{ choice.choice }}</span>
                            </label>
                        </div>
                    </div>
                    <div class="text-end mt-4">
                          <button class="btn-next" (click)="nextQuestion()" *ngIf="!isLastQuestion">
                              Next
                          </button>
                          <button class="btn-submit" (click)="submitExam()" *ngIf="isLastQuestion">
                              Submit
                          </button>
                      </div>          
                </div>
                <div class="progress-section mt-5">
                    <div class="d-flex justify-content-between mb-2">
                        <div class="progress-label">Progress</div>
                        <div class="progress-count">{{ answeredQuestionsCounts }} of {{ flatQuestions.length }} questions answered</div>
                    </div>
                    <div class="progress-bar-container">
                        <div class="progress-bar-bg">
                            <div class="progress-bar-fill" 
                                [style.width.%]="(answeredQuestionsCounts/ flatQuestions.length) * 100"
                                style="background-color: green;"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</form>